/**
 * Mobile Boost PFS filter: tablist / tab / tabpanel roles, aria-selected, hidden panels,
 * roving tabindex, and arrow key navigation (APG tabs pattern).
 */
(function () {
  var MOBILE_MQ = '(max-width: 767px)';
  var WRAPPER_SEL = '.boost-pfs-filter-options-wrapper';
  /** Vertical mobile filter tree (Boost may also add boost-pfs-filter-tree-mobile-style2). */
  var MOBILE_TREE_SEL = '.boost-pfs-filter-tree-v';

  function isMobile() {
    try {
      return window.matchMedia(MOBILE_MQ).matches;
    } catch (e) {
      return window.innerWidth < 768;
    }
  }

  function getPair(optionEl) {
    var tab = optionEl.querySelector('.boost-pfs-filter-option-title-heading');
    var panel = optionEl.querySelector('.boost-pfs-filter-option-content');
    return tab && panel ? { tab: tab, panel: panel } : null;
  }

  function findActiveIndex(options) {
    var idx = -1;
    for (var i = 0; i < options.length; i++) {
      if (options[i].classList.contains('active')) idx = i;
    }
    return idx;
  }

  function syncTabStates(wrapper) {
    var options = wrapper.querySelectorAll('.boost-pfs-filter-option');
    if (!options.length) return;

    var activeIdx = findActiveIndex(options);
    if (activeIdx === -1) activeIdx = 0;

    for (var i = 0; i < options.length; i++) {
      var pair = getPair(options[i]);
      if (!pair) continue;
      var isActive = i === activeIdx;
      pair.tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      pair.tab.setAttribute('tabindex', isActive ? '0' : '-1');
      if (isActive) {
        pair.panel.removeAttribute('hidden');
        pair.panel.removeAttribute('aria-hidden');
      } else {
        pair.panel.setAttribute('hidden', 'hidden');
        pair.panel.setAttribute('aria-hidden', 'true');
      }
    }
  }

  function onTablistKeydown(e) {
    if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(e.key)) return;
    var wrapper = e.currentTarget;
    var tabs = Array.prototype.slice.call(wrapper.querySelectorAll('[role="tab"]'));
    if (!tabs.length) return;
    var i = tabs.indexOf(document.activeElement);
    if (i === -1) return;
    e.preventDefault();
    var next = i;
    if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
    else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
    else if (e.key === 'Home') next = 0;
    else if (e.key === 'End') next = tabs.length - 1;
    var tab = tabs[next];
    tab.focus();
    if (typeof tab.click === 'function') tab.click();
  }

  function teardown(wrapper) {
    if (wrapper._mgTabKeydown) {
      wrapper.removeEventListener('keydown', wrapper._mgTabKeydown);
      wrapper._mgTabKeydown = null;
    }
    if (wrapper._mgTabObserver) {
      wrapper._mgTabObserver.disconnect();
      wrapper._mgTabObserver = null;
    }
    wrapper.removeAttribute('data-mg-tabs-a11y');
  }

  function clearRoles(wrapper) {
    var options = wrapper.querySelectorAll('.boost-pfs-filter-option');
    wrapper.removeAttribute('role');
    wrapper.removeAttribute('aria-label');
    wrapper.removeAttribute('aria-orientation');
    wrapper.removeAttribute('data-mg-tabs-count');
    wrapper.removeAttribute('data-mg-tabs-a11y');
    for (var i = 0; i < options.length; i++) {
      var pair = getPair(options[i]);
      if (!pair) continue;
      pair.tab.removeAttribute('role');
      pair.tab.removeAttribute('id');
      pair.tab.removeAttribute('aria-controls');
      pair.tab.removeAttribute('aria-selected');
      pair.tab.removeAttribute('tabindex');
      pair.panel.removeAttribute('role');
      pair.panel.removeAttribute('id');
      pair.panel.removeAttribute('aria-labelledby');
      pair.panel.removeAttribute('hidden');
      pair.panel.removeAttribute('aria-hidden');
    }
  }

  function enhance(wrapper) {
    if (!wrapper || !isMobile()) return;

    var tree = wrapper.closest(MOBILE_TREE_SEL);
    if (!tree) return;

    var options = wrapper.querySelectorAll('.boost-pfs-filter-option');
    var count = options.length;
    if (!count) return;

    if (
      wrapper.getAttribute('data-mg-tabs-a11y') === '1' &&
      wrapper.getAttribute('data-mg-tabs-count') === String(count)
    ) {
      syncTabStates(wrapper);
      return;
    }

    teardown(wrapper);
    clearRoles(wrapper);

    var baseId = wrapper.id || 'mg-boost-pfs-filter-tabs';
    if (!wrapper.id) wrapper.id = baseId;

    wrapper.setAttribute('role', 'tablist');
    wrapper.setAttribute('aria-label', 'Filter categories');
    wrapper.setAttribute('aria-orientation', 'horizontal');

    for (var i = 0; i < options.length; i++) {
      var pair = getPair(options[i]);
      if (!pair) continue;
      var tid = baseId + '-tab-' + i;
      var pid = baseId + '-panel-' + i;
      pair.tab.setAttribute('role', 'tab');
      pair.tab.setAttribute('id', tid);
      pair.tab.setAttribute('aria-controls', pid);
      pair.panel.setAttribute('role', 'tabpanel');
      pair.panel.setAttribute('id', pid);
      pair.panel.setAttribute('aria-labelledby', tid);
    }

    wrapper._mgTabKeydown = onTablistKeydown;
    wrapper.addEventListener('keydown', wrapper._mgTabKeydown);

    var observer = new MutationObserver(function () {
      syncTabStates(wrapper);
    });
    for (var j = 0; j < options.length; j++) {
      observer.observe(options[j], { attributes: true, attributeFilter: ['class'] });
    }
    wrapper._mgTabObserver = observer;

    wrapper.setAttribute('data-mg-tabs-a11y', '1');
    wrapper.setAttribute('data-mg-tabs-count', String(count));
    syncTabStates(wrapper);
  }

  function scan() {
    if (!isMobile()) {
      document.querySelectorAll(WRAPPER_SEL + '[data-mg-tabs-a11y="1"]').forEach(function (w) {
        teardown(w);
        clearRoles(w);
      });
      return;
    }
    document.querySelectorAll(MOBILE_TREE_SEL + ' ' + WRAPPER_SEL).forEach(enhance);
  }

  var debounceTimer;
  function scheduleScan() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(scan, 120);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  window.addEventListener('load', scheduleScan);
  window.addEventListener('resize', scheduleScan);

  document.addEventListener(
    'click',
    function (e) {
      var t = e.target;
      if (t && t.closest && t.closest('.boost-pfs-filter-tree-mobile-button')) {
        setTimeout(scan, 0);
        setTimeout(scan, 400);
        setTimeout(scan, 2000);
      }
    },
    true
  );

  [500, 2000, 4500].forEach(function (ms) {
    setTimeout(scan, ms);
  });

  window.MG_BOOST_PFS_FILTER_TABS_A11Y = { refresh: scan };
})();
